import DataGrid from 'components/DataGrid';
import LoadingScreen from 'components/LoadingScreen';
import { Suspense } from 'react';
import { useWADataConfig } from './WADataGrid.config';

const WADataGrid = () => {
  const { config, data, loading } = useWADataConfig();
  return (
    <Suspense fallback={<LoadingScreen />}>
      <DataGrid config={config} data={data} loading={loading} />
    </Suspense>
  );
};

export default WADataGrid;
